import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

//STYLES
import './Category.css'

//COMPONENTS
import TaskLink from '../../../components/bar/TaskLink'
import Button from '../../../components/ui/Button'
import ParagraphsParsers from '../../../components/misc/ParagaphsParser'

export default function Category({tasks, setTasks, categories}) {
  const { id: catId } = useParams()
  const [ cat, setCategory] = useState(null)
  
  const nav = useNavigate()
  // const filteredTasks = filterTasks('catId', catId)

  useEffect( () => {
    if (categories) {
      setCategory( categories.find( (c) => c.id === catId))
    }
  }, [categories, catId])

  const goBack = () => {
    nav('/bar/home')
  }

  const catDesc = cat?.desc?.map( (p, index) => {
    return {...p, attr:{...p.attr, key: index}}
  })

  const resetComplete = () => {
    setTasks( (prev) =>  {
      return prev.map( (t) => {
        if (t.catId === catId) {
          return {...t, completed: false}
        } else {
          return t
        }
      })
    })
    console.log('reset')
  }

  return (
    <div className='cat-container'>
      { cat && (
        <h1 className='title-btn'>
          <Button 
            icon="BACK" 
            clickFunction={goBack} 
            text={cat.catName}
          />
          {setTasks && <Button 
            icon="RELOAD"
            clickFunction={resetComplete}
          />}
        </h1>
      )}
      { cat && <ParagraphsParsers paragraphs={catDesc} />}
      { tasks && tasks.map((task) => {
        if (task.catId === catId) {
          return <TaskLink key={task.id} task={task} setTasks={setTasks}/>
        } else {
          return null
        }
      })}
    </div>
  )
}
